import http, { e } from "./http";
import loginService from "./login.service";

const fileService = {
  getAllImages() {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.get(e("file/all/images"), null, headers).then((r) => {
      return r.data;
    });
  },
  uploadZip(file) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.upload(e("file/upload/zip"), file, headers);
  },
  uploadImage(file) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.upload(e("file/upload/image"), file, headers);
  },
  uploadDocument(file) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.upload(e("file/upload/document"), file, headers);
  },
  uploadBrochure(file) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.upload(e("file/upload/brochure"), file, headers);
  },
  deleteFile(idFile) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.remove(e(`file/${idFile}`), headers).then((r) => {
      return r.data;
    });
  },
  deleteNotInUse() {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.remove(e("file/notinuse"), headers).then((r) => {
      return r.data;
    });
  },
  importZip(idFile) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.put(e(`file/import/${idFile}`), null, headers).then((r) => {
      return r.data;
    });
  },
  importOop(idFile) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.put(e(`file/oop/${idFile}`), null, headers).then((r) => {
      return r.data;
    });
  },
  mapZip(data) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.post(e("file/map"), data, headers).then((r) => {
      return r.data;
    });
  },
  getBrochureMetadata(idBrochure) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http
      .get(e(`file/brochure/${idBrochure}/metadata`), null, headers)
      .then((r) => {
        return r.data;
      });
  },
};
export default fileService;
